/* This is the EMIS Last Student for secondary school components */
<template>
  <v-container>
    <div>
      <span v-html="title + ' ' + lastacc + ' និងសិស្សអាហារូបករណ៍'"></span>
    </div>
    <div>
      <table style="height: 72px" border="1px;" width="850" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                width: 250px;
                height: 50px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              សិស្ស
            </td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៧</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៨</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៩</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ១០</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ១១</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ១២</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <tr v-for="(value, row) in d2.length - lastRow" :key="row">
            <!-- Input columns -->
            <td v-if="row == 2" class="row-title">{{ d2[row] + " " + curacc }}</td>
            
            <td v-if="row == 0 || row == 1 || row == 3 || row == 4" class="row-title">{{ d2[row] + " " + lastacc }}</td>
            <td v-if="row == 5" class="row-title">{{ d2[row]}}</td>

            <td v-for="(value, col) in data[row].dt.length" :key="col" class="row-data">
              <numberinput v-model="data[row].dt[col]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { d2 } from "@/utils/ascf/secConfig.js";
export default {
  props: ["data", "curacc", "lastacc", "cur_cod", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      d2: d2,
    };
  },
  computed: {
    //variable control the last added row of 20-21
    lastRow: function () {
      if (this.cur_cod > 12) return 0;
      else return 1;
    },
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.row-data {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-title {
  width: 200px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
.row-header {
  width: 100px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>